import throttle from '../utils/throttle';
export default class cardFade {
    constructor() {
        this.cardsContent = document.querySelectorAll('.card-fade');
        // if not mobile
        if (window.innerWidth > 1024) {
          this.cardsContent.forEach((el) => {
            this.cardAnimation(el)
          })
        }
    }

    cardAnimation(e) {
      const offset = 153; // Offset in pixels
      const cardsItem = e.querySelectorAll('.service__item');
      const saveHeight = Array.from(cardsItem).map(card => card.getBoundingClientRect().height);
      window.addEventListener('scroll', function () {
        cardsItem.forEach((card, i) => {
          if (i < cardsItem.length - 1) {
            const cardRect = card.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const parentRect = card.parentElement.getBoundingClientRect();
            const distanceFromTop = cardRect.top - offset;
            const percent = (parentRect.top - saveHeight[i] + (saveHeight[i] * i)  + offset) / 3
            const opacityPercent = (parentRect.top - saveHeight[i] + (saveHeight[i] * i)  + offset * 2)
            if (distanceFromTop < 0 && cardRect.bottom > 0) {
              const scaleValue = Math.max(0, 1 + percent / saveHeight[i]);
              const opacityValue = Math.max(0, 1 + opacityPercent / saveHeight[i]);
              card.style.transform = `scale(${scaleValue})`;
              card.style.opacity = opacityValue;
            } else {
              card.style.transform = 'scale(1)';
              card.style.opacity = 1;
            }
          }
        });
      })
    }

}
